import { CORE_ROUTE_MAP } from './api-route-maps/core-route-map';
import { DEVICES_ROUTE_MAP } from './api-route-maps/devices-route-map';
import { NOTIFICATIONS_ROUTE_MAP } from './api-route-maps/notifications-route-map';
import { TARIFFS_ROUTE_MAP } from './api-route-maps/tariffs-route-map';
import { AllResponseTypes } from './dynamic-route-helpers';

export type HTTPMethod = 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE';

export const RETRIEVE_ROUTE_MAP: Record<string, AllResponseTypes> = {
  ...CORE_ROUTE_MAP,
  ...NOTIFICATIONS_ROUTE_MAP,
  ...DEVICES_ROUTE_MAP,
  ...TARIFFS_ROUTE_MAP,
};

export const ROUTE_MAP: Record<HTTPMethod, Record<string, AllResponseTypes>> = {
  GET: RETRIEVE_ROUTE_MAP,
  POST: {},
  PATCH: {},
  DELETE: {},
  PUT: {},
};
